export const questionReplies = {
  mainContainer: {
    display: "flex",
    flexDirection: "column",
    fontFamily: "Inter",
  },
  nodeInitial: {
    position: "relative",
    top: "20px",
    left: "10px",
    color: "#797b8c",
    textAlign: "center",
    paddingRight: "35px",
  },
  bottomRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "row",
    "&:hover": {
      cursor: "pointer",
    },
  },
  nodeBody: {
    margin: 0,
    padding: 0,
    display: "flex",
    alignItems: "center",
    // justifyContent: "center",
    flexDirection: "row",
    height: "30px",
    minWidth: "100px",
    fontSize: "16px",
    color: "#22304a",
    backgroundColor: "#fff",
    borderRadius: "20px",
    marginBottom: "30px",
  },
  titleName: {
    marginLeft: "10px",
    fontSize: "12px",
    fontFamily: "Inter",
    fontWeight: 550,
  },
  iconButton: {
    marginLeft: "10px",
    iconButton: "#33bd00",
    height: "15px",
    width: "15px",
    "&:hover": {
      backgroundColor: "#33bd00",
    },
  },
  nodeIcon: {
    fontSize: "11px",
    color: "#fff",
    fontWeight: 600,
  },
  addIcon: {
    fontSize: "14px",
    height: "20px",
    width: "20px",
    color: "#22304a",
    borderRadius: "50%",
    backgroundColor: "white",
    marginLeft: "4px",
    transition: "visibility 0s, color 0.2s",
    position: "relative",
    bottom: "13px",
    "&:hover": {
      color: "blue",
    },
  },
  leftHandle: {
    background: "#566d89",
    opacity: "0",
    top: "-11px",
    position: "relative",
  },
  rightHandle: {
    background: "#566d89",
    opacity: "0",
    top: "3px",
    left: "26px",
    position: "relative",
  },
};
